import { render, staticRenderFns } from "./OLDocumentSent.vue?vue&type=template&id=0601680c&"
import script from "./OLDocumentSent.vue?vue&type=script&lang=js&"
export * from "./OLDocumentSent.vue?vue&type=script&lang=js&"
import style0 from "./OLDocumentSent.vue?vue&type=style&index=0&id=0601680c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports